import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容板块",
    links: [
      { label: "事件合集", to: "/collections" },
      { label: "今日热榜", to: "/collections" },
      { label: "大事件时间线", to: "/#timeline" },
      { label: "精选解读", to: "/#featured" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about#principles" },
      { label: "发展历程", to: "/about#milestones" },
      { label: "联系我们", to: "/about#contact" },
    ],
  },
  {
    title: "帮助中心",
    links: [
      { label: "常见问题", to: "/faq" },
      { label: "如何追更合集", to: "/faq" },
      { label: "信息纠错反馈", to: "/about#contact" },
      { label: "内容说明", to: "/faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-eye-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">蝌蚪黑料</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              把全网热门事件按话题整理成合集，一条时间线看完前因后果与后续更新。做整理，不做定性。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="mailto:hello@kedou-heiliao.example.com"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-background-100 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="发送邮件"
              >
                <i className="ri-mail-line"></i>
              </a>
              <Link
                to="/about#contact"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-background-100 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="联系与反馈"
              >
                <i className="ri-chat-3-line"></i>
              </Link>
              <Link
                to="/collections"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-background-100 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="浏览合集"
              >
                <i className="ri-compasses-2-line"></i>
              </Link>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-bold text-background-50 tracking-wide">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © 2026 蝌蚪黑料 · 内容整理与话题追踪平台
          </p>
          <p className="text-xs text-background-300">
            本站信息以公开渠道整理为主，涉及争议请以官方说明为准
          </p>
        </div>
      </div>
    </footer>
  );
}